import { defineMobileFormWindow } from "@app/overlay";
import {
    StockPlacementContentForm,
    type StockPlacementContentFormProps,
} from "./components/StockPlacementContentForm/StockPlacementContentForm";

/** Реестр overlay-окон карточки размещения ТМЦ. */
export const stockPlacementCardWindows = {
    content: defineMobileFormWindow<StockPlacementContentFormProps>({
        key: "stock.placement.content",
        title: "Размещение строки ПО",
        component: StockPlacementContentForm,
    }),
};
